<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed? 0: 5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
        <!-- 按钮操作区域 -->
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div style="display: flex;margin-top: 10px;">
            <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
            <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
          </div>
          <!-- 树-->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('表编号')">
                  <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户编号')">
                  <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户姓名')">
                  <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('用户地址')">
                  <a-input :placeholder="$t('请输入用户地址')" v-model="queryParam.userAddr"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="toggleSearchStatus">
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('用户手机号')">
                    <a-input :placeholder="$t('请输入用户手机号')" v-model="queryParam.userPhone"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :xl="12" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('查询起止时间')">
                  <a-range-picker
                    v-model="date"
                    format="YYYY-MM-DD"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    @change="onDateRangeChange"
                  />
                </a-form-item>
              </a-col>
              </template>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
          <a-button type="primary" icon="download" @click="handleExportXls($t('日用量报表'))">{{ $t('导出') }}</a-button>
          <a-dropdown v-if="selectedRowKeys.length > 0">
            <a-menu slot="overlay">
              <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
          </a-dropdown>
        </div>
        <!-- 汇总显示 -->
        <a-descriptions :column="4">
          <a-descriptions-item :label="$t('使用总量')">
            <span v-if="loading">
              <a-spin size="small" />
            </span>
            <span v-else>
              {{useTotal.sumUse+' m³'}}
            </span>
          </a-descriptions-item>
        </a-descriptions>
        <!-- table区域-begin -->
        <div class="table-fixed">
          <span style="float:right;">
            <a-popover :title="$t('自定义列')" trigger="click" placement="leftBottom">
              <template slot="content">
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                          <a-col :span="6" :key="item.key">
                            <a-checkbox :value="item.dataIndex" :key="item.title">{{ item.title }}</a-checkbox>
                          </a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </template>
            </a-popover>
          </span>
          <a-table
            ref="table"
            size="middle"
            tableLayout="fixed"
            :scroll="{ x: 1100 }"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">

            <div slot="filterDropdown">
              <a-card>
                <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                  <a-row>
                    <template v-for="item in defColumns">
                      <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                        <a-col :span="6" :key="item.key">
                          <a-checkbox :value="item.dataIndex" :key="item.title">{{ item.title }}</a-checkbox>
                        </a-col>
                      </template>
                    </template>
                  </a-row>
                </a-checkbox-group>
              </a-card>
            </div>
            <span slot="action" slot-scope="text, record">
              <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            </span>
          </a-table>
        </div>
        <meter-user-water-report-day-modal ref="modalForm" @ok="modalFormOk"></meter-user-water-report-day-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterUserWaterReportDayModal from './modules/MeterUserWaterReportDayModal'
  import { getAction } from '@/api/manage'
  import {getDaysBetween} from'@/utils/util'
  import moment from 'moment';
  import Vue from 'vue'

  export default {
    name: 'MeterUserWaterReportDayList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      MeterUserWaterReportDayModal
    },
    data () {
      return {
        description: '日用量报表',
        collapsed: false,
        date:[],
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/meterUserWaterReportDay/list",
          delete: "/jeecg-charge/meter/meterUserWaterReportDay/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserWaterReportDay/deleteBatch",
          exportXlsUrl: "jeecg-charge/meter/meterUserWaterReportDay/exportXlsForDayUseSumList",
          importExcelUrl: "/jeecg-charge/meter/meterUserWaterReportDay/importExcel",
          getDayUseReportSum: "/jeecg-charge/meter/meterUserWaterReportDay/dayUseReportSum"
        },
        useTotal: {sumUse:0},
        dateType: 2,
        disableMixinCreated: true
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.loadData();
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
      this.loadTree();
      this.initColumns();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon'
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },
          /*
          {
            title:'用户电话',
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true
          },
          */
          {
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            // width:150,
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('日用量(m³)'),
            align:"center",
            dataIndex: 'dayUse',
            width:120,
            ellipsis: true
          },/*{
            title:'表口径',
            align:"center",
            dataIndex: 'mtCaliber',
            width:100,
            ellipsis: true
          },{
            title:'上报月份',
            align:"center",
            dataIndex: 'reportMonth',
            width:100,
            ellipsis: true
          },*/{
            title: this.$t('报表日期'),
            align:"center",
            dataIndex: 'reportDate',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      loadListData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      getDayUseReportSum() {
        this.useTotal = {sumUse:0}
        let params = this.getQueryParams();
        // this.sumUseLoading = true;
        getAction(this.url.getDayUseReportSum, params).then((res) => {
          if (res.success&&res.result.records.length>0) {
            this.useTotal = res.result.records[0];
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      loadData(arg) {
        // 判断时间跨度不能超过30天
        if(!this.queryParam.beginDate||!this.queryParam.beginDate) {
          //return this.$message.warning("请选择查询起止时间");
          let date = moment().subtract(1, 'day');
          this.date[0] = date;
          this.date[1] = date;
          this.queryParam.beginDate = moment(this.date[0]).format('YYYY-MM-DD');
          this.queryParam.endDate = moment(this.date[1]).format('YYYY-MM-DD');
        }
        let betweenDay = getDaysBetween(this.queryParam.beginDate,this.queryParam.endDate);
        console.log("相差天数："+betweenDay)
        if(betweenDay<0) {
          return this.$message.warning(this.$t("结束时间不能小于开始时间"));
        }else if(betweenDay>30) {
          return this.$message.warning(this.$t("查询起止时间跨度不能超过30天"));
        }
        this.getDayUseReportSum();
        this.loadListData(arg);
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadListData();
      },
      handleEdit(row){
        this.$refs.modalForm.edit(row);
        this.$refs.modalForm.title = this.$t("编辑");
        this.$refs.modalForm.disableSubmit = false;
      }
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>